import React from "react"
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './termsConditions.css'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
// -------------------------------------------------

/**
 * Terms & Conditions Component
 * Displays the company's terms of service with:
 * - Hero section with gradient background
 * - Styled content sections with icons
 * - Last updated date
 */
const TermsConditions = () => {

  // Terms sections with icons
  const sections = [
    {
      icon: 'fa-solid fa-handshake',
      title: 'Acceptance of Terms',
      content: 'By accessing or using Travel Pradesh services, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you may not use our services.'
    },
    {
      icon: 'fa-solid fa-ticket',
      title: 'Booking & Reservations',
      content: 'All bookings are subject to availability and confirmation. Prices are subject to change without notice until a booking is confirmed. Full payment or deposit may be required at the time of booking.'
    },
    {
      icon: 'fa-solid fa-ban',
      title: 'Cancellation & Refunds',
      content: 'Cancellation policies vary by service provider. Refunds will be processed according to the specific terms of each booking. Administrative fees may apply to cancellations or modifications.'
    },
    {
      icon: 'fa-solid fa-user-shield',
      title: 'User Responsibilities',
      content: 'You are responsible for providing accurate and complete information when making bookings. You must ensure you have valid travel documents including passports, visas, and health certificates as required.'
    },
    {
      icon: 'fa-solid fa-scale-balanced',
      title: 'Liability Limitations',
      content: 'Travel Pradesh acts as an intermediary between you and travel service providers. We are not liable for actions, errors, or omissions of airlines, hotels, tour operators, or other third-party services.'
    },
    {
      icon: 'fa-solid fa-file-contract',
      title: 'Changes to Terms',
      content: 'We reserve the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the modified terms. Major changes will be communicated via email.'
    }
  ];

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className='policy-hero'>
        <div className='policy-hero-overlay'></div>
        <div className='container policy-hero-content'>
          <div className='policy-icon'>
            <i className='fa-solid fa-file-contract'></i>
          </div>
          <h1>Terms & Conditions</h1>
          <p>Please read these terms carefully before using our services</p>
        </div>
      </section>

      {/* Last Updated */}
      <section className='policy-updated'>
        <div className='container'>
          <span className='update-badge'>
            <i className='fa-solid fa-calendar-check me-2'></i>
            Last Updated: December 2024
          </span>
        </div>
      </section>

      {/* Terms Content */}
      <section className='policy-content'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-10'>
              {/* Introduction */}
              <div className='policy-intro'>
                <p>
                  Welcome to Travel Pradesh. These Terms and Conditions govern your use of our website, mobile
                  applications, and services. By making a booking or using our platform, you acknowledge that you
                  have read, understood, and agree to be bound by these terms.
                </p>
              </div>

              {/* Terms Sections */}
              {sections.map((section, index) => (
                <div key={index} className='policy-section'>
                  <div className='section-icon'>
                    <i className={section.icon}></i>
                  </div>
                  <div className='section-content'>
                    <h3>{section.title}</h3>
                    <p>{section.content}</p>
                  </div>
                </div>
              ))}

              {/* Contact Section */}
              <div className='policy-contact'>
                <h3><i className='fa-solid fa-question-circle me-2'></i>Questions?</h3>
                <p>
                  If you have any questions about these Terms & Conditions, please contact our support team:
                </p>
                <a href='mailto:support@travelpradesh.com' className='contact-email'>
                  support@travelpradesh.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}

export default TermsConditions
